import DeleteIcon from './DeleteIcon'

export default DeleteIcon
